function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useTranslation } from 'react-i18next';
import { HEADING_DISABLED_WIDGETS, FORMAT_VALUES_DISABLED_WIDGETS } from '../constants';

var useCustomizationSections = function useCustomizationSections(isQueryBootstrapped, query, widgetType, hiddenOptions) {
  var sectionsConfig = {
    headingSettings: {
      isDisabled: null
    },
    formatValues: {
      isNotAvailable: null,
      isDisabled: null
    },
    componentSettings: {
      isDisabled: null,
      hiddenOptions: hiddenOptions
    }
  };

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (!isQueryBootstrapped) {
    return {
      headingSettings: {
        isDisabled: t('widget_customization.settings_disabled')
      },
      formatValues: {
        isNotAvailable: null,
        isDisabled: t('widget_customization.settings_disabled')
      },
      componentSettings: {
        isDisabled: t('widget_customization.settings_disabled'),
        hiddenOptions: hiddenOptions
      }
    };
  }

  if (HEADING_DISABLED_WIDGETS.includes(widgetType)) {
    sectionsConfig = _objectSpread(_objectSpread({}, sectionsConfig), {}, {
      headingSettings: {
        isDisabled: t('widget_customization.settings_disabled_for_widget', {
          widget: widgetType
        })
      }
    });
  }

  if (FORMAT_VALUES_DISABLED_WIDGETS.includes(widgetType)) {
    sectionsConfig = _objectSpread(_objectSpread({}, sectionsConfig), {}, {
      formatValues: {
        isDisabled: t('widget_customization.settings_disabled_for_widget', {
          widget: widgetType
        }),
        isNotAvailable: null
      }
    });
  }

  return sectionsConfig;
};

export default useCustomizationSections;